import { Box } from "@mui/material"
import { ComplianceStatus } from "../types"
import CompliancePlipLight from "./CompliancePlipLight"

type CompliancePlipGroup = {
  complianceStatuses: Record<number, number>,
  complianceMessages: Map<number, string>,
}

const CompliancePlipGroup = (props: CompliancePlipGroup) => {
  const { complianceStatuses, complianceMessages } = props

  return (
    <Box>
      <CompliancePlipLight status={ComplianceStatus.Expired} message={complianceMessages.get(ComplianceStatus.Expired)} className="m-r-8" />
      <span className="m-r-12 muted-text">{complianceStatuses[ComplianceStatus.Expired]}</span>
      <CompliancePlipLight status={ComplianceStatus.Expiring} message={complianceMessages.get(ComplianceStatus.Expiring)} className="m-r-8" />
      <span className="m-r-12 muted-text">{complianceStatuses[ComplianceStatus.Expiring]}</span>
      <CompliancePlipLight status={ComplianceStatus.Ok} message={complianceMessages.get(ComplianceStatus.Ok)} className="m-r-8" />
      <span className="m-r-12 muted-text">{complianceStatuses[ComplianceStatus.Ok]}</span>
      <CompliancePlipLight status={ComplianceStatus.Inactive} message={complianceMessages.get(ComplianceStatus.Inactive)} className="m-r-8" />
      <span className="muted-text">{complianceStatuses[ComplianceStatus.Inactive]}</span>
    </Box>    
  )
}

export default CompliancePlipGroup
